module.exports = __webpack_public_path__ + "img/chinesecompany80.20d8d075.png";